import { Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import 'dayjs/locale/de';
import { useAuth } from '../../hooks/useAuth';

function Home() {
    const auth = useAuth();

    const navigateTo = (url: string) => {
        window.location.href = url;
    }

    return (
        <Box alignItems={'center'} justifyContent={'center'} width='100%'>
            {auth.isAuthenticated && (
                <div>
                    <Grid container spacing={3} >
                        <Grid item xs={12} md={3}>
                            <Button fullWidth={true} style={{ height: 60 }} variant="contained" color='primary' onClick={(e) => navigateTo(process.env.REACT_APP_CABIN_REPORTS_URL ?? '')} >Cabin Reports</Button>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button fullWidth={true} style={{ height: 60, textTransform: 'none' }} variant="contained" color='primary' onClick={(e) => navigateTo(process.env.REACT_APP_EFORMS_URL ?? '')}>eForms</Button>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button fullWidth={true} style={{ height: 60 }} variant="contained" color='primary' onClick={(e) => navigateTo(process.env.REACT_APP_FEEDBACK_URL ?? '')}>Feedback</Button>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Button fullWidth={true} style={{ height: 60 }} variant="contained" color='primary' onClick={(e) => navigateTo(process.env.REACT_APP_CAM_URL ?? '')}>Main/ Control Data</Button>
                        </Grid>
                    </Grid>
                </div>
            )}
        </Box>
    );
}

export default Home;